import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import DroneContent from '../../mdx/services/drone-photography.mdx';
import './DronePhotographyDetails.css';

const Heading = ({ children, ...props }) => <h2 className="drone-photography-details__heading" {...props}>{children}</h2>;
const Subheading = ({ children, ...props }) => <h3 className="drone-photography-details__subheading" {...props}>{children}</h3>;
const Paragraph = ({ children, ...props }) => <p className="drone-photography-details__paragraph" {...props}>{children}</p>;

const DronePhotographyDetails = () => (
  <section className="drone-photography-details">
    <div className="drone-photography-details__container">
      <div className="drone-photography-details__content">
        <MDXProvider components={{ h2: Heading, h3: Subheading, p: Paragraph }}>
          <DroneContent />
        </MDXProvider>
      </div>
    </div>
  </section>
);

export default DronePhotographyDetails;
